import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const tiposEmpleado = [
    { value: 0, label: 'Cajero' },
    { value: 1, label: 'Bateador' },
    { value: 2, label: 'Promotor' },
    { value: 3, label: 'Freidor' },
    { value: 4, label: 'Vendedor ambulante' },
    { value: 5, label: 'Administrador' }
];

const FiltrosEmpleado = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const sucursalesListado = useSelector(state => state.sucursales.listado);

    const [nombre, setNombre] = useState('');
    const [tipoData, setTipoData] = useState(null);
    const [sucursalesData, setSucursalesData] = useState([]);

    useEffect(() => {
        if (show) {
            setNombre(filtros.nombre || '');
            setTipoData(filtros.tipo !== null ? tiposEmpleado.find(t => t.value === filtros.tipo) ?? null : null);
            const sucOpc = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
            setSucursalesData((filtros.sucursales || []).map(id => sucOpc.find(s => s.value === id)).filter(Boolean));
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            nombre: nombre.trim(),
            tipo: tipoData ? tipoData.value : null,
            sucursales: sucursalesData.map(s => s.value)
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setNombre('');
        setTipoData(null);
        setSucursalesData([]);
        handleAplicar({ nombre: '', tipo: null, sucursales: [] });
        handleCerrar();
    };

    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));

    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    <div className="col-6">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre"
                                id="filtro_nombre"
                                value={nombre}
                                onChange={e => setNombre(e.target.value)}
                            />
                            <label htmlFor="filtro_nombre">Nombre / Apellido</label>
                        </div>
                    </div>
                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Tipo de empleado"
                                options={tiposEmpleado}
                                value={tipoData}
                                onChange={option => setTipoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-12 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Sucursales"
                                options={sucursalesOpciones}
                                value={sucursalesData}
                                onChange={options => setSucursalesData(options || [])}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isMulti
                                isClearable
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosEmpleado;
